export enum TypesOfNotification {
  GROUP_CHATS_MESSAGE,
  P2P_CHATS_MESSAGE,
  MENTION_AND_QUOTE,
  GROUP_CHATS_CALL,
  P2P_CALL,
  PIN_MESSAGE,
  ROOM_CREATING,
}
